import { render, staticRenderFns } from "./RevenueSplitPartnerView.vue?vue&type=template&id=7112d4ea&scoped=true"
import script from "./RevenueSplitPartnerView.vue?vue&type=script&lang=js"
export * from "./RevenueSplitPartnerView.vue?vue&type=script&lang=js"
import style0 from "./RevenueSplitPartnerView.vue?vue&type=style&index=0&id=7112d4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7112d4ea",
  null
  
)

export default component.exports